import SectionNavigation from "../../Utility/SectionNavigation";
import { ISSUES_SECTION_NAV_ITEMS } from "./issuesTabPermissions";

export { ISSUES_SECTION_NAV_ITEMS } from "./issuesTabPermissions";

const IssuesNavigation = ({ items, activeTab, onTabChange }) => {
  const navItems = items ?? ISSUES_SECTION_NAV_ITEMS;
  return (
    <SectionNavigation
      items={navItems}
      activeTab={activeTab}
      onTabChange={onTabChange}
      iconSize={16}
    />
  );
};

export default IssuesNavigation;
